import React from "react"
import Modal from "../Modal"

interface ISuccessModalProps {
  close: any
  children?: string | JSX.Element | JSX.Element[]
  title?: string,
  headerIconColor?: "green" | "red"
}

export default function ModalSuccess({title, close, headerIconColor = "green", children}: ISuccessModalProps) {
  return(
    <Modal
      title={title}
      dialogSizeSuffix={"w320"}
      headerAlignCenter={true}
      close={close}
      headerIcon={true}
      headerIconColor={headerIconColor}
    >
      {children}
    </Modal>
  )
}